import { RootState } from 'src/app/store';
import { NavigationState } from './navigationStore';
import { NavigationItem } from '../types';

const getState = (state: RootState): NavigationState => state.navigation;

export const getNavigationItems = (state: RootState): NavigationItem[] =>
  getState(state).navigationItems;

export const getEmbeddedState = (state: RootState): boolean => getState(state).isEmbedded;
export const getPowerUnitNumber = (state: RootState): string => getState(state).powerUnitNumber;
